import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["entityIdField", "entityTypeField", "entityIdHidden"]

    connect() {
      this.pivotTableViews = JSON.parse(this.element.dataset.pivotTableViews)
      this.pivotTableDelivery = JSON.parse(this.element.dataset.pivotTableDelivery)

      this.setupPivotTableViewListener()

      // Esperamos a que TomSelect se inicialice
      requestAnimationFrame(() => {

        this.initializeForm()
      })
    }

    setupPivotTableViewListener() {
      const pivotTableViewSelect = this.element.querySelector('[name*="pivot_table_view_id"]')
      if (pivotTableViewSelect) {
        requestAnimationFrame(() => {
          if (pivotTableViewSelect.tomselect) {
            pivotTableViewSelect.tomselect.on('change', (value) => {
              this.onPivotTableViewChange({ target: { value: value } })
            })
          } else {
            pivotTableViewSelect.addEventListener('change', (event) => {
              this.onPivotTableViewChange(event)
            })
          }
        })
      }
    }

    // Initialize form for editing existing delivery
    initializeForm() {
      // Set the pivot table view first
      const pivotTableViewSelect = this.element.querySelector('[name*="pivot_table_view_id"]')
      if (pivotTableViewSelect && this.pivotTableDelivery.pivot_table_view_id) {
        pivotTableViewSelect.value = this.pivotTableDelivery.pivot_table_view_id
      }

      // Update field visibility based on current pivot table view
      if (pivotTableViewSelect && pivotTableViewSelect.value) {
        this.updateFieldVisibility(pivotTableViewSelect.value)
      }
      // Then set entity values from existing delivery
      this.setEntityValues(
        this.pivotTableDelivery.entity_type,
        this.pivotTableDelivery.entity_id
      )

    }

    // Method to handle the change of the pivot table view
    onPivotTableViewChange(event) {
      const pivotTableViewId = event.target.value

      if (!pivotTableViewId) {
        this.clearEntityFields()
        return
      }

      // Update field visibility
      this.updateFieldVisibility(pivotTableViewId)

      const pivotTableView = this.pivotTableViews[pivotTableViewId] || {}
      this.setEntityValues(
        pivotTableView.entity || "",
        pivotTableView.entity_id || ""
      )
    }

    // Update field visibility based on pivot table view
    updateFieldVisibility(pivotTableViewId) {
      const pivotTableView = this.pivotTableViews[pivotTableViewId] || {}

      if (this.hasEntityIdFieldTarget) {
        const entityIdSelect = this.entityIdFieldTarget.querySelector("select")

        if (pivotTableView.entity === "level") {
          // Mostrar el select y su wrapper
          this.entityIdFieldTarget.style.visibility = "visible"
          if (entityIdSelect?.tomselect?.wrapper) {
            entityIdSelect.tomselect.wrapper.style.display = ''
          }
        } else {
          // Ocultar el select y su wrapper
          this.entityIdFieldTarget.style.visibility = "hidden"
          if (entityIdSelect?.tomselect?.wrapper) {
            entityIdSelect.tomselect.wrapper.style.display = 'none'
          }
        }
      }
    }

    // Set entity type and id values in all relevant fields
    setEntityValues(entityType, entityId) {
      // Set entity type
      if (this.hasEntityTypeFieldTarget) {
        this.entityTypeFieldTarget.value = entityType
      }

      // Set entity id in visible field
      if (this.hasEntityIdFieldTarget) {
        const entityIdSelect = this.entityIdFieldTarget.querySelector("select")
        if (entityIdSelect) {
          const ajaxUrlBase = entityIdSelect.dataset.selectAjaxUrlBase;

          if (entityId && ajaxUrlBase) {
            fetch(`${ajaxUrlBase}?q=${entityId}&by_id=true`, {
              headers: {
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
              }
            })
            .then(response => response.json())
            .then(data => {
              if (data && data.length > 0) {
                requestAnimationFrame(() => {
                  if (entityIdSelect.tomselect) {
                    data.forEach(option => entityIdSelect.tomselect.addOption(option));
                    entityIdSelect.tomselect.setValue(entityId);

                    if (this.hasEntityIdHiddenTarget) {
                      this.entityIdHiddenTarget.value = entityId;
                    }

                    entityIdSelect.tomselect.on('change', (value) => {
                      if (this.hasEntityIdHiddenTarget) {
                        this.entityIdHiddenTarget.value = value;
                      }
                    });
                  }
                });
              }
            })
            .catch(error => {
              console.error('Error fetching level data:', error);
            });
          }
        }
      }

      // Set entity id in hidden field
      if (this.hasEntityIdHiddenTarget) {
        this.entityIdHiddenTarget.value = entityId
      }
    }

    // Clear all entity fields
    clearEntityFields() {
      if (this.hasEntityIdFieldTarget) {
        const entityIdSelect = this.entityIdFieldTarget.querySelector("select")
        this.entityIdFieldTarget.style.visibility = "hidden"
        if (entityIdSelect?.tomselect?.wrapper) {
          entityIdSelect.tomselect.wrapper.style.display = 'none'
        }
      }
      this.setEntityValues("", "")
    }
}